setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
            if (item.target.className === 'grid grid--uniform grid-products grid--view-items') {
                BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
            }
            if (item.target.className === 'grid-products list-view-items') {
                BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
            }
            if (item.target.className === 'grid grid--uniform grid-products') {
                BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
            }
        }
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}, 300);